export const formatPhone = (rawPhone) => {
  const [, country, code, dial1, dial2, dial3] = /(\+\d{2})(\d{3})(\d{3})(\d{2})(\d{2})/.exec(rawPhone);
  return `${country} ${code} ${dial1} ${dial2} ${dial3}`;
};
